var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse2, _path40, _path41, _path42, _path43, _ellipse3, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterHandsUp5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 147,
    viewBox: "0 0 173 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.386 61.2776C120.386 61.2776 132.2 53.3806 139.512 37.1113C139.512 37.1113 146.914 19.9007 139.147 12.6685C139.147 12.6685 132.794 6.85604 127.183 13.7185C127.183 13.7185 127.239 46.154 116.185 63.0413C116.185 63.0413 115.942 63.9277 116.485 63.9907C116.961 64.0603 118.045 63.5233 120.386 61.2776Z",
    fill: "url(#paint0_linear_14011_164663)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.44 15.3054C142.894 13.5351 142.448 11.8907 141.442 11.6351C140.437 11.3795 139.256 12.6081 138.802 14.3784C138.351 16.1492 138.798 17.7937 139.804 18.0492C139.845 18.0583 139.89 18.0679 139.931 18.0733C140.907 18.1986 142.007 17.0018 142.44 15.3054Z",
    fill: "url(#paint1_linear_14011_164663)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.898 11.4005C138.349 9.62957 137.902 7.98509 136.897 7.72951C135.895 7.47441 134.71 8.70252 134.26 10.4734C133.806 12.2438 134.252 13.8883 135.258 14.1439C135.299 14.153 135.344 14.1626 135.386 14.1679C136.362 14.2932 137.462 13.0964 137.898 11.4005Z",
    fill: "url(#paint2_linear_14011_164663)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.441 13.47C131.471 13.3763 132.172 11.8214 131.996 9.9995C131.824 8.1781 130.85 6.78479 129.816 6.87802C128.786 6.97564 128.085 8.53051 128.262 10.3485C128.42 12.0294 129.26 13.3462 130.199 13.4667C130.281 13.4772 130.361 13.4795 130.441 13.47Z",
    fill: "url(#paint3_linear_14011_164663)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2898 62.3631C50.2898 62.3631 38.9838 53.7546 32.6855 37.0664C32.6855 37.0664 26.3563 19.4333 34.5533 12.6924C34.5533 12.6924 41.2511 7.28154 46.4299 14.476C46.4299 14.476 44.3799 46.8468 54.3736 64.3818C54.3736 64.3818 54.5619 65.2814 54.0167 65.311C53.5369 65.3512 52.4875 64.7485 50.2898 62.3631Z",
    fill: "url(#paint4_linear_14011_164663)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1934 14.0271C42.1712 13.8702 41.5676 12.2752 41.855 10.4675C42.1384 8.66011 43.1965 7.32935 44.2226 7.48596C45.2451 7.64676 45.8487 9.24177 45.561 11.0455C45.2999 12.7135 44.3797 13.9761 43.4352 14.0386C43.3526 14.0441 43.2734 14.0415 43.1934 14.0271Z",
    fill: "url(#paint5_linear_14011_164663)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8774 11.5032C35.5367 9.70793 36.0836 8.09403 37.103 7.90076C38.1187 7.70775 39.2254 9.00638 39.566 10.8016C39.9104 12.5966 39.3636 14.2105 38.3441 14.4037C38.3025 14.4103 38.2571 14.4171 38.2152 14.4199C37.2332 14.4849 36.2091 13.2228 35.8774 11.5032Z",
    fill: "url(#paint6_linear_14011_164663)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1042 15.1211C30.7598 13.3262 31.3067 11.7124 32.3261 11.5191C33.3455 11.3258 34.4484 12.6247 34.7928 14.4196C35.1334 16.2147 34.5865 17.8286 33.5671 18.0218C33.5255 18.0284 33.4801 18.0352 33.4382 18.038C32.4562 18.103 31.4322 16.8409 31.1042 15.1211Z",
    fill: "url(#paint7_linear_14011_164663)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6506 81.0744C85.605 85.7993 82.8644 103.154 81.6962 109.849C81.4716 111.237 82.5274 112.491 83.9426 112.491H93.2428C96.1632 112.491 96.3204 108.147 93.4001 107.968C92.9957 107.946 92.6138 107.923 92.2319 107.923C90.2776 107.901 89.2667 105.639 90.5247 104.161C98.0502 95.3833 102.633 83.6944 104.003 79.91C104.408 78.768 103.846 77.514 102.723 77.0438C101.06 76.372 98.3871 76.0361 95.5566 76.0361C89.2891 76.0361 82.2578 77.6932 83.6506 81.0744Z",
    fill: "url(#paint8_linear_14011_164663)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3831 111.339C57.2599 111.809 56.6982 113.063 57.1026 114.205C58.4729 117.99 63.0557 129.679 70.5814 138.457C71.8394 139.935 70.8285 142.197 68.8741 142.219C68.4922 142.219 68.1103 142.241 67.7059 142.264C64.7855 142.443 64.9428 146.787 67.8632 146.787H77.1635C78.5788 146.787 79.6346 145.533 79.41 144.145C78.2418 137.449 75.5011 120.095 77.4555 115.37C78.8483 111.988 71.8169 110.331 65.5493 110.331C62.7188 110.331 60.0455 110.667 58.3831 111.339Z",
    fill: "url(#paint9_linear_14011_164663)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0446 115.37C98.999 120.095 96.2583 137.449 95.0902 144.145C94.8655 145.533 95.9214 146.787 97.3366 146.787H106.637C109.557 146.787 109.715 142.443 106.794 142.264C106.39 142.241 106.008 142.219 105.626 142.219C103.672 142.197 102.661 139.935 103.919 138.457C111.444 129.679 116.027 117.99 117.397 114.205C117.802 113.063 117.24 111.809 116.117 111.339C114.455 110.667 111.781 110.331 108.951 110.331C102.683 110.331 95.6518 111.988 97.0446 115.37Z",
    fill: "url(#paint10_linear_14011_164663)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.614 20.8037C107.376 22.9245 100.936 30.9386 103.083 34.1479C105.21 37.3573 115.114 34.5609 118.352 32.44C121.572 30.3005 122.457 25.9838 120.311 22.7556C118.955 20.7286 116.733 19.6401 114.474 19.6401C113.137 19.6401 111.8 20.0154 110.614 20.8037Z",
    fill: "url(#paint11_linear_14011_164663)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.002 27.9222C120.002 24.6495 118.364 22.6965 114.391 22.6963C110.419 22.696 108.919 27.4986 108.919 29.5448C108.919 32.1026 109.919 33.4502 113.447 33.4502C116.975 33.4502 120.002 31.195 120.002 27.9222Z",
    fill: "url(#paint12_linear_14011_164663)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8789 22.7556C49.7513 25.9838 50.6174 30.3005 53.837 32.44C57.0755 34.5609 66.9791 37.3573 69.1067 34.1479C71.2531 30.9386 64.8139 22.9245 61.5754 20.8037C60.3892 20.0154 59.0524 19.6401 57.7156 19.6401C55.4562 19.6401 53.2345 20.7286 51.8789 22.7556Z",
    fill: "url(#paint13_linear_14011_164663)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1885 27.9222C52.1885 24.6495 53.8265 22.6966 57.799 22.6963C61.7715 22.696 63.2715 27.4986 63.2715 29.5448C63.2715 32.1026 62.2713 33.4502 58.7436 33.4502C55.2158 33.4502 52.1885 31.195 52.1885 27.9222Z",
    fill: "url(#paint14_linear_14011_164663)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0265 12.2622C89.0265 15.4861 87.9555 18.0995 86.6344 18.0995C85.3132 18.0995 84.2422 15.4861 84.2422 12.2622C84.2422 9.03828 85.3132 6.4248 86.6344 6.4248C87.9555 6.4248 89.0265 9.03828 89.0265 12.2622Z",
    fill: "url(#paint15_linear_14011_164663)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6267 13.3688C86.7377 15.9813 86.0766 18.7272 87.147 19.4961C88.2174 20.2649 90.6179 18.7743 92.5147 16.1539C94.4036 13.5414 95.0647 10.7955 93.9943 10.0267C93.8054 9.8933 93.5693 9.82269 93.3017 9.82269C92.0818 9.82269 90.185 11.2192 88.6267 13.3688Z",
    fill: "url(#paint16_linear_14011_164663)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2759 10.0273C78.2056 10.7961 78.8666 13.5418 80.7554 16.1542C82.6521 18.7744 85.0524 20.2649 86.1227 19.4961C87.193 18.7273 86.5319 15.9816 84.6431 13.3692C83.0849 11.2198 81.1883 9.82337 79.9684 9.82337C79.7009 9.82337 79.4648 9.89397 79.2759 10.0273Z",
    fill: "url(#paint17_linear_14011_164663)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.548 56.9497C125.428 56.2743 125.304 55.5958 125.176 54.9143C125.176 54.9143 124.319 51.1923 123.09 46.2979C121.493 52.395 119.273 58.3247 116.185 63.0414C116.185 63.0414 115.942 63.9277 116.485 63.9908C116.961 64.0604 118.045 63.5234 120.386 61.2776C120.386 61.2776 122.526 59.8472 125.548 56.9497Z",
    fill: "#147497"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9985 49.5502C50.208 54.9209 51.9314 60.0947 54.3747 64.3817C54.3747 64.3817 54.563 65.2813 54.0178 65.3109C53.5379 65.3511 52.4886 64.7484 50.2908 62.363C50.2908 62.363 49.076 61.438 47.2209 59.6067C47.7858 55.9241 48.3895 52.5705 48.9985 49.5502Z",
    fill: "#147497"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 31.2747C56.4844 31.2747 47.1394 54.9573 46.8226 99.9543C46.8226 99.9543 42.8629 136.741 86.5783 136.662C86.5783 136.662 118.89 139.11 125.225 112.032C125.225 112.032 128.076 87.1657 122.374 55.8256C122.374 55.8256 117.464 33.8008 114.534 27.1697C114.534 27.1697 107.802 15.1705 86.5783 14.6179C86.5783 14.6179 86.3407 14.5389 85.9447 14.5389C82.3018 14.5389 63.3743 15.3283 56.4844 31.2747Z",
    fill: "url(#paint18_linear_14011_164663)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.0254,
    cy: 41.3655,
    rx: 28.8833,
    ry: 24.8362,
    fill: "url(#paint19_linear_14011_164663)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.416 76.9449C111.416 83.6044 100.254 89.0039 86.4824 89.0039C72.7129 89.0039 61.5487 81.9875 61.5487 76.9449C61.5487 70.2773 72.7129 75.3047 86.4824 75.3047C100.254 75.3047 111.416 70.2773 111.416 76.9449Z",
    fill: "#FFF8E1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6347 74.111C72.8685 74.111 61.6973 69.0844 61.6973 75.7437C61.6973 82.4031 72.8685 87.815 86.6347 87.815C100.401 87.815 111.572 82.4031 111.572 75.7437C111.572 73.0836 109.787 72.2948 106.787 72.2948C102.26 72.2948 94.9165 74.111 86.6347 74.111Z",
    fill: "url(#paint20_linear_14011_164663)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0332 86.4269C78.5006 87.3116 82.4408 87.8078 86.6381 87.8078C90.7608 87.8078 94.6512 87.3282 98.0771 86.4682C95.9867 84.8724 92.735 82.8052 90.9599 83.7065C88.2142 85.1204 85.5265 84.8558 83.5523 83.8388C83.0214 83.5577 82.3246 83.3923 81.5117 83.3923C79.7282 83.3923 77.389 84.2026 75.0332 86.4269Z",
    fill: "url(#paint21_radial_14011_164663)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90.3441 94.112C89.173 94.2513 87.9315 94.3306 86.635 94.3306C85.4996 94.3306 84.405 94.2696 83.3614 94.1608C73.5867 92.9762 69.0278 88.4857 70.7447 88.9677C72.1606 89.1243 76.5542 91.0512 82.1312 91.6939C83.5777 91.8668 85.0956 91.9644 86.635 91.9583C88.2988 91.9654 89.9402 91.8505 91.4917 91.6481C96.9045 90.9719 101.138 89.1182 102.525 88.9677C104.21 88.502 99.8281 92.8267 90.3441 94.112Z",
    fill: "#181D1B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8616 72.3945C64.8287 72.6106 64.8156 72.8268 64.8156 73.0594C64.8156 75.2802 66.2253 77.0752 67.9669 77.0752C69.7052 77.0752 71.1182 75.2802 71.1182 73.0594C71.1182 72.9284 71.1116 72.7974 71.0984 72.6663C69.3569 72.4469 67.8059 72.2929 66.4882 72.2929C65.8967 72.2929 65.3545 72.3224 64.8616 72.3945Z",
    fill: "url(#paint22_linear_14011_164663)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2108 75.9965C66.6077 76.4571 67.1195 76.6669 67.3566 76.4646C67.5922 76.2622 67.4646 75.7244 67.0684 75.2646C66.6729 74.8042 66.1597 74.5928 65.9241 74.7952C65.6863 74.9982 65.8153 75.536 66.2108 75.9965Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.482 73.0612C72.4818 75.2825 73.8904 77.0777 75.63 77.0782C77.2238 77.0768 78.5304 75.5876 78.7531 73.6402C76.5051 73.3948 74.4052 73.0961 72.4935 72.844C72.4813 72.9127 72.4801 72.9883 72.482 73.0612Z",
    fill: "url(#paint23_linear_14011_164663)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8768 75.9965C74.2729 76.4577 74.7855 76.6669 75.0226 76.4646C75.2582 76.2622 75.1306 75.7244 74.7344 75.2646C74.3375 74.8041 73.8257 74.5928 73.5893 74.7959C73.3523 74.9982 73.4813 75.536 73.8768 75.9965Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2993 77.0762C84.7533 77.0762 85.9813 75.8229 86.3408 74.1097C84.2174 74.0984 82.1618 73.9654 80.1989 73.7851C80.4658 75.656 81.7502 77.0762 83.2993 77.0762Z",
    fill: "url(#paint24_linear_14011_164663)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5442 75.9961C81.94 76.4563 82.4534 76.666 82.6888 76.4634C82.925 76.2616 82.7979 75.7233 82.4014 75.2637C82.005 74.8027 81.4917 74.5916 81.2569 74.7949C81.0199 74.9974 81.1479 75.5351 81.5442 75.9961Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.923 74.09C88.2768 75.8116 89.5105 77.0762 90.9699 77.0762C92.5388 77.0762 93.8469 75.6121 94.082 73.6886C92.1244 73.8928 90.0575 74.0459 87.923 74.09Z",
    fill: "url(#paint25_linear_14011_164663)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M89.211 75.9968C89.6059 76.4577 90.1193 76.6674 90.3548 76.4648C90.5918 76.2624 90.4639 75.7247 90.0673 75.2652C89.6709 74.8042 89.1584 74.5924 88.9221 74.7956C88.6852 74.998 88.8131 75.5357 89.211 75.9968Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5018 73.5283C95.6848 75.5253 97.0153 77.0776 98.6377 77.077C100.377 77.0767 101.787 75.282 101.785 73.0618C101.785 72.9419 101.78 72.8255 101.768 72.7125C99.8753 72.9519 97.7685 73.2642 95.5018 73.5283Z",
    fill: "url(#paint26_linear_14011_164663)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8768 75.9965C97.2737 76.4571 97.7855 76.6669 98.0226 76.4646C98.2582 76.2622 98.1306 75.7244 97.7344 75.2646C97.3375 74.8041 96.8265 74.5921 96.5893 74.7959C96.3537 74.9983 96.4813 75.536 96.8768 75.9965Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M103.174 72.542C103.158 72.7123 103.144 72.8826 103.144 73.0595C103.144 75.2803 104.557 77.0752 106.296 77.0752C108.037 77.0752 109.453 75.2803 109.453 73.0595C109.453 72.9121 109.45 72.768 109.437 72.6271C108.714 72.388 107.814 72.293 106.769 72.293C105.714 72.293 104.508 72.3913 103.174 72.542Z",
    fill: "url(#paint27_linear_14011_164663)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 75.9965C104.94 76.4577 105.453 76.6669 105.69 76.4646C105.925 76.2622 105.798 75.7244 105.401 75.2646C105.006 74.8042 104.493 74.5928 104.256 74.7959C104.019 74.9982 104.148 75.536 104.544 75.9965Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.4492 46.9562C85.4492 54.6437 79.198 60.875 71.4869 60.875C63.7769 60.875 57.5246 54.6437 57.5246 46.9562C57.5246 39.2707 63.7769 33.0394 71.4869 33.0394C79.198 33.0394 85.4492 39.2707 85.4492 46.9562Z",
    fill: "#181D1B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5435 46.9572C84.5435 54.1462 78.697 59.974 71.4851 59.974C64.2732 59.974 58.4268 54.1462 58.4268 46.9572C58.4268 39.7682 64.2732 33.9404 71.4851 33.9404C78.697 33.9404 84.5435 39.7682 84.5435 46.9572Z",
    fill: "url(#paint28_radial_14011_164663)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5115 46.9555C78.5115 50.8229 75.3664 53.9579 71.4867 53.9579C67.607 53.9579 64.4619 50.8229 64.4619 46.9555C64.4619 43.0882 67.607 39.9531 71.4867 39.9531C75.3664 39.9531 78.5115 43.0882 78.5115 46.9555Z",
    fill: "url(#paint29_radial_14011_164663)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7725 46.9552C74.7725 48.7652 73.3025 50.2305 71.4867 50.2305C69.6719 50.2305 68.2009 48.7652 68.2009 46.9552C68.2009 45.1461 69.6719 43.6798 71.4867 43.6798C73.3025 43.6798 74.7725 45.1461 74.7725 46.9552Z",
    fill: "#2D2A49"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.4873,
    cy: 43.4966,
    rx: 3.91113,
    ry: 2.99561,
    fill: "url(#paint30_linear_14011_164663)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M115.265 46.9562C115.265 54.6437 109.013 60.875 101.302 60.875C93.5924 60.875 87.3401 54.6437 87.3401 46.9562C87.3401 39.2707 93.5924 33.0394 101.302 33.0394C109.013 33.0394 115.265 39.2707 115.265 46.9562Z",
    fill: "#181D1B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.358 46.9572C114.358 54.1462 108.512 59.974 101.3 59.974C94.0876 59.974 88.2412 54.1462 88.2412 46.9572C88.2412 39.7682 94.0876 33.9404 101.3 33.9404C108.512 33.9404 114.358 39.7682 114.358 46.9572Z",
    fill: "url(#paint31_radial_14011_164663)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.327 46.9555C108.327 50.8229 105.182 53.958 101.302 53.958C97.4225 53.958 94.2773 50.8229 94.2773 46.9555C94.2773 43.0882 97.4225 39.9531 101.302 39.9531C105.182 39.9531 108.327 43.0882 108.327 46.9555Z",
    fill: "url(#paint32_radial_14011_164663)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M104.588 46.9552C104.588 48.7652 103.118 50.2305 101.302 50.2305C99.4873 50.2305 98.0163 48.7652 98.0163 46.9552C98.0163 45.1461 99.4873 43.6798 101.302 43.6798C103.118 43.6798 104.588 45.1461 104.588 46.9552Z",
    fill: "#2D2A49"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.303,
    cy: 43.4966,
    rx: 3.91113,
    ry: 2.99561,
    fill: "url(#paint33_linear_14011_164663)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.4736 86.3614C90.4736 86.7824 88.8017 87.123 86.739 87.123C84.6763 87.123 83.0054 86.7824 83.0054 86.3614C83.0054 85.9414 84.6763 85.6008 86.739 85.6008C88.8017 85.6008 90.4736 85.9414 90.4736 86.3614Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.3666 136.114C96.3666 136.114 101.171 135.545 108.232 132.702C108.232 132.702 106.298 135.469 105.095 137.042C105.095 137.042 101.565 138.645 96.0082 138.646L96.3666 136.114Z",
    fill: "#181D1B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.1347 136.126C78.1347 136.126 73.7007 136.101 66.6386 133.259C66.6386 133.259 68.1375 135.498 69.3981 137.019C69.3981 137.019 72.4402 138.348 78.5085 138.67L78.1347 136.126Z",
    fill: "#181D1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14011_164663",
    x1: 132.711,
    y1: 60.0892,
    x2: 116.828,
    y2: 57.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14011_164663",
    x1: 142.095,
    y1: 18.351,
    x2: 138.312,
    y2: 17.8654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14011_164663",
    x1: 137.55,
    y1: 14.4465,
    x2: 133.766,
    y2: 13.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14011_164663",
    x1: 131.67,
    y1: 13.655,
    x2: 127.758,
    y2: 13.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14011_164663",
    x1: 38.0614,
    y1: 60.4191,
    x2: 54.057,
    y2: 59.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14011_164663",
    x1: 41.9556,
    y1: 14.1362,
    x2: 45.8907,
    y2: 13.8756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_164663",
    x1: 36.038,
    y1: 14.5649,
    x2: 39.8444,
    y2: 14.3128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_164663",
    x1: 31.2611,
    y1: 18.1821,
    x2: 35.0673,
    y2: 17.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCF4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3B98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B98E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_164663",
    x1: 81.6738,
    y1: 76.0403,
    x2: 104.138,
    y2: 76.0403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_164663",
    x1: 56.9678,
    y1: 110.334,
    x2: 79.4324,
    y2: 110.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_164663",
    x1: 117.532,
    y1: 110.334,
    x2: 95.0677,
    y2: 110.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14011_164663",
    x1: 121.478,
    y1: 18.2406,
    x2: 102.65,
    y2: 18.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14011_164663",
    x1: 108.919,
    y1: 28.2643,
    x2: 120.002,
    y2: 28.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F86C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14011_164663",
    x1: 50.7115,
    y1: 18.2399,
    x2: 69.5397,
    y2: 18.2399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14011_164663",
    x1: 63.2715,
    y1: 28.2643,
    x2: 52.1882,
    y2: 28.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F86C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14011_164663",
    x1: 84.2428,
    y1: 6.42419,
    x2: 89.0272,
    y2: 6.42419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14011_164663",
    x1: 86.6354,
    y1: 9.82494,
    x2: 94.5059,
    y2: 9.82494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14011_164663",
    x1: 78.7643,
    y1: 9.82557,
    x2: 86.6342,
    y2: 9.82557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14011_164663",
    x1: 46.7434,
    y1: 14.5497,
    x2: 125.938,
    y2: 14.5497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14011_164663",
    x1: 87.0254,
    y1: 16.5293,
    x2: 87.0254,
    y2: 46.9812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14011_164663",
    x1: 111.572,
    y1: 67.9653,
    x2: 111.572,
    y2: 86.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE1722"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_14011_164663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.5551 85.6) scale(8.29513 2.97649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC1A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14011_164663",
    x1: 65.8079,
    y1: 76.8197,
    x2: 65.8079,
    y2: 73.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14011_164663",
    x1: 73.3072,
    y1: 76.7221,
    x2: 73.4686,
    y2: 73.8324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14011_164663",
    x1: 81.166,
    y1: 76.9003,
    x2: 81.166,
    y2: 74.6462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_14011_164663",
    x1: 88.8924,
    y1: 76.8952,
    x2: 88.8924,
    y2: 74.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_14011_164663",
    x1: 96.3682,
    y1: 76.9391,
    x2: 96.2426,
    y2: 73.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_14011_164663",
    x1: 104.139,
    y1: 76.8197,
    x2: 104.139,
    y2: 73.5443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_14011_164663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.4864 46.9559) scale(13.0584 13.0168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_14011_164663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.4864 46.9559) scale(7.02479 7.00241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8DD5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_14011_164663",
    x1: 71.4944,
    y1: 40.501,
    x2: 71.4944,
    y2: 43.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_14011_164663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.301 46.9561) scale(13.0584 13.0168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_14011_164663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.302 46.9556) scale(7.0248 7.00241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8DD5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_14011_164663",
    x1: 101.31,
    y1: 40.501,
    x2: 101.31,
    y2: 43.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterHandsUp5);
export default __webpack_public_path__ + "static/media/MonsterHandsUp5.d75bec1a6bf7e39c417f10e2e33084a7.svg";
export { ForwardRef as ReactComponent };